import { ca } from '@cian/analytics';
import { EPageBlock, ICategoriesBlockPageExtra } from '../../../types/analytics';
import { IPage } from '../../../types/redux';

export function trackCategoriesShow(page: IPage) {
  const pageExtra: ICategoriesBlockPageExtra = {
    block: EPageBlock.Categories,
  };

  return ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'show_sopr',
    label: 'Block',
    page: {
      ...page,
      extra: pageExtra,
    },
  });
}
